import { render, staticRenderFns } from "./wxchronic.vue?vue&type=template&id=974fa176&scoped=true&"
import script from "./wxchronic.vue?vue&type=script&lang=js&"
export * from "./wxchronic.vue?vue&type=script&lang=js&"
import style0 from "./wxchronic.vue?vue&type=style&index=0&id=974fa176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974fa176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('974fa176')) {
      api.createRecord('974fa176', component.options)
    } else {
      api.reload('974fa176', component.options)
    }
    module.hot.accept("./wxchronic.vue?vue&type=template&id=974fa176&scoped=true&", function () {
      api.rerender('974fa176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/wxchronic.vue"
export default component.exports